const Reason = {
  api: 'APIError',
  notFound: 'NotFound',
  errorBoundary: 'ErrorBoundary',
};

function createError({
  message,
  reason,
  stack = null,
  status = null,
  ...rest
}) {
  const error = new Error(message);

  error.reason = reason;
  error.stack = stack;
  error.status = status || rest.code;
  error.rest = rest;

  return error;
}

export { Reason };

export default createError;
